// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ee-0";
export var actionModalContentContainer = "_ee-1";
export var createTagButton = "_ee-2";
export var footerContainer = "_ee-7";
export var fullWidthDivider = "_ee-3";
export var hasCreateTagButton = "_ee-4";
export var noCreateTagButton = "_ee-5";
export var tagsContainer = "_ee-6";
export var tagsModalContentContainer = "_ee-8";